export interface ProcessState {
  isPending: () => this is PendingState
  isProcessing: () => this is ProcessingState
  start: () => ProcessingState | never
  reset: () => PendingState
}

export class PendingState implements ProcessState {
  isPending(): this is PendingState {
    return true
  }
  isProcessing(): this is ProcessingState {
    return false
  }
  start(): ProcessingState {
    return new ProcessingState()
  }
  reset(): PendingState {
    return new PendingState()
  }
}

export class ProcessingState implements ProcessState {
  isPending(): this is PendingState {
    return false
  }
  isProcessing(): this is ProcessingState {
    return true
  }
  start(): never {
    throw new Error('Invalid state transition')
  }
  reset(): PendingState {
    return new PendingState()
  }
}
